/**
 * Transforms sub-product identifiers into a simplified or generic form, providing
 * a default when unspecified. This aids in standardizing the representation of
 * sub-product names across different contexts.
 */

const transformSubProducts = (subProduct?: string | null) => {
	if (!subProduct) {
		return 'unknown';
	}
	if (subProduct === 'family') {
		return 'platform';
	}
	if (subProduct === 'jira-servicedesk') {
		return 'serviceDesk';
	}
	if (subProduct.startsWith('jira-')) {
		return subProduct.replace('jira-', '');
	}
	return subProduct;
};

export default transformSubProducts;
